import { render, staticRenderFns } from "./requirement.vue?vue&type=template&id=cbf2771e&scoped=true"
import script from "./requirement.vue?vue&type=script&lang=js"
export * from "./requirement.vue?vue&type=script&lang=js"
import style0 from "./requirement.vue?vue&type=style&index=0&id=cbf2771e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf2771e",
  null
  
)

export default component.exports